import { createApp } from 'vue'
import App from './SocialConservation.vue'

createApp(App).mount('#app-social-conservation')
